import {getApiUrl} from "../utils/util-functions";
import {RainforestCardBrandEnum} from "../enums/rainforest-card-brand.enum";

export const getRainforestSession = async () => {
    return fetch(getApiUrl() + '/payment/rainforest/session', {
        method: 'POST'
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'];
        });
};

export const getRainforestPayinConfig = async (
    amount: string,
    isPaymentMethodAch: boolean,
    cardBrand?: RainforestCardBrandEnum | null,
    abortSignal?: AbortSignal,
) => {
    const body: Record<string, unknown> = {
        amount,
        type: isPaymentMethodAch ? 'ach' : 'card',
    };
    if (cardBrand) {
        body.card_brand = cardBrand;
    }
    return fetch(getApiUrl() + '/payment/rainforest/payin-config', {
        signal: abortSignal,
        method: 'POST',
        body: JSON.stringify(body),
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'];
        });
};
